import { render, staticRenderFns } from "./DesvincularCursoModal.vue?vue&type=template&id=08c848c4"
import script from "./DesvincularCursoModal.vue?vue&type=script&lang=js"
export * from "./DesvincularCursoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports